import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import regionService from "../services/region-service";

export const regionSearchSchema = z.object({
	search: z.string().optional(),
	court_type: z.string().nullable().optional(),
	court_level: z.string().nullable().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
});

export const regionsQueryOptions = (
	search?: z.infer<typeof regionSearchSchema>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["region", search],
		queryFn: () =>
			regionService.list(
				transformSearch(search, ["search", "court_type", "court_level"]),
			),
		...options,
	});
};

export const regionQueryOptions = (regionId: string) => {
	return queryOptions({
		queryKey: ["region", regionId],
		queryFn: () => regionService.findById(regionId),
	});
};

export const useRegionCreateMutation = (regionId?: string) => {
	return useMutation({
		mutationKey: ["region", regionId],
		mutationFn: regionService.create,
		meta: {
			successMessage: "Region created successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["region"] }),
	});
};

export const useRegionMutation = (regionId?: string) => {
	return useMutation({
		mutationKey: ["region", regionId],
		mutationFn: regionService.upsert,
		meta: {
			successMessage: "Region updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["region"] }),
	});
};
